var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.802,
    height: 47.822,
    viewBox: "0 0 47.802 47.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report_3029319",
    transform: "translate(-1.393 -1.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16115",
    "data-name": "Path 16115",
    d: "M27.853,53.219a16.576,16.576,0,0,1-12.384-6.491A16.7,16.7,0,0,1,14.179,28.2a16.559,16.559,0,0,1,5.765-5.938A16.734,16.734,0,0,1,27.9,19.812v-.557c0-1.378,0-2.755,0-4.134A2.387,2.387,0,0,1,30.388,12.6q9.811-.006,19.622.015a1.433,1.433,0,0,1,.913.383q4.251,4.2,8.451,8.452a1.44,1.44,0,0,1,.383.913q.028,17.782.015,35.562A2.379,2.379,0,0,1,57.3,60.418q-13.471.008-26.942,0a2.38,2.38,0,0,1-2.46-2.449c-.012-1.543-.008-3.088-.012-4.631a.774.774,0,0,0-.036-.117Zm1.639-17.506H44.348c.838,0,1.095.262,1.075,1.11-.009.381-.039.762-.072,1.142A16.685,16.685,0,0,1,32.566,52.754c-1,.233-2.018.35-3.075.528v4.393c0,.915.23,1.147,1.144,1.147H57.028c.918,0,1.152-.231,1.152-1.14V22.958h-.6q-2.788,0-5.577,0a2.407,2.407,0,0,1-2.584-2.578q0-2.814,0-5.628v-.56H30.636c-.914,0-1.143.23-1.143,1.148V35.711Zm-10.89,12A15.023,15.023,0,0,0,35.378,50.1a14.869,14.869,0,0,0,6.748-6.6,14.524,14.524,0,0,0,1.67-6.16,1.555,1.555,0,0,0-.2-.033q-7.143,0-14.285.008a.882.882,0,0,0-.544.258c-1.267,1.244-2.517,2.5-3.773,3.759l-6.4,6.384Zm-1.12-1.144c.06-.052.124-.1.181-.157q5-5,9.993-10.01a1.008,1.008,0,0,0,.233-.653q.02-6.923.009-13.846v-.487a15.1,15.1,0,0,0-13.435,9.936,14.892,14.892,0,0,0,3.019,15.219Zm33.528-31.1v.3c0,1.527,0,3.055,0,4.582,0,.737.279,1,1.035,1.006q2.265,0,4.532,0a2.417,2.417,0,0,0,.294-.027l-5.862-5.861Z",
    transform: "translate(-10.578 -11.133)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16120",
    "data-name": "Path 16120",
    d: "M155.65,51.342V43.676c0-.87.251-1.111,1.136-1.1a16.732,16.732,0,0,1,16.1,13.732,25.615,25.615,0,0,1,.281,2.767c.047.742-.259,1.03-1,1.03q-7.763,0-15.528,0c-.712,0-.99-.282-.991-1q0-3.882,0-7.765Zm1.624-7.142V58.472h14.271A15.152,15.152,0,0,0,157.274,44.2Z",
    transform: "translate(-135.141 -37.122)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16121",
    "data-name": "Path 16121",
    d: "M246.7,240.24a7.171,7.171,0,1,1-7.186,7.131,7.192,7.192,0,0,1,7.186-7.131Zm-5.593,7.179a5.577,5.577,0,1,0,5.607-5.584,5.59,5.59,0,0,0-5.607,5.584Z",
    transform: "translate(-207.844 -208.487)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16122",
    "data-name": "Path 16122",
    d: "M305.93,114.73v1.525H299.6V114.73Z",
    transform: "translate(-259.939 -99.676)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16123",
    "data-name": "Path 16123",
    d: "M299.69,150.51H306v1.551H299.69Z",
    transform: "translate(-260.017 -130.695)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16124",
    "data-name": "Path 16124",
    d: "M305.92,188.144h-6.31V186.61h6.31Z",
    transform: "translate(-259.948 -161.992)",
    fill: "#0098da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16127",
    "data-name": "Path 16127",
    d: "M266.392,271.96l1.148,1.12c-.112.122-.206.234-.31.338q-2.127,2.131-4.259,4.259c-.579.577-.93.574-1.514-.008-.726-.722-1.45-1.448-2.187-2.182l1.144-1.139,1.752,1.848c1.45-1.454,2.829-2.835,4.224-4.236Z",
    transform: "translate(-224.975 -235.987)",
    fill: "#0098da"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSen);
export default __webpack_public_path__ + "static/media/sen.37cf0a6b058a70cb5d5dfc758b66d19d.svg";
export { ForwardRef as ReactComponent };